export default {
      id: "table-col-before-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#table-col-before-usage",
      toString: function () {
        return this.url;
      }
    }